module.exports = __webpack_public_path__ + "img/idCard-back.60dc6352.png";